import {
  differenceInDays,
  endOfMonth,
  isBefore,
  isAfter,
} from 'date-fns';

export const DAY_WIDTH_DESKTOP = 5;
export const DAY_WIDTH_MOBILE = 3;
export const LEFT_COL_WIDTH_DESKTOP = 75;
export const LEFT_COL_WIDTH_MOBILE = 48;
// Parking uses a wider label column — its rows need to fit a badge,
// spot label, tag badge and assign button. Independent of calendar
// so tightening calendar widths never squishes parking again.
export const PARKING_LEFT_COL_WIDTH_DESKTOP = 300;
export const PARKING_LEFT_COL_WIDTH_MOBILE = 200;

export let DAY_WIDTH = DAY_WIDTH_DESKTOP;
export const ROW_HEIGHT = 44;
export const HEADER_HEIGHT = 52;
export let LEFT_COL_WIDTH = LEFT_COL_WIDTH_DESKTOP;
export let PARKING_LEFT_COL_WIDTH = PARKING_LEFT_COL_WIDTH_DESKTOP;
export const PROPERTY_HEADER_HEIGHT = 40;
export const BAR_HEIGHT = 28;
export const BAR_TOP_OFFSET = 8;

// Responsive dims are toggled from CalendarPage via a matchMedia listener.
// All consumers import DAY_WIDTH / LEFT_COL_WIDTH as live ES-module bindings,
// so mutating these `let` exports here is reflected everywhere on the next
// render. We keep a subscriber set so CalendarPage can force a re-render
// (which cascades down to every sub-component) when the values change.
const dimListeners = new Set();
export function subscribeCalendarDims(fn) {
  dimListeners.add(fn);
  return () => { dimListeners.delete(fn); };
}
export function setResponsiveCalendarDims({ isMobile }) {
  const nextDay = isMobile ? DAY_WIDTH_MOBILE : DAY_WIDTH_DESKTOP;
  const nextLeft = isMobile ? LEFT_COL_WIDTH_MOBILE : LEFT_COL_WIDTH_DESKTOP;
  const nextParkLeft = isMobile ? PARKING_LEFT_COL_WIDTH_MOBILE : PARKING_LEFT_COL_WIDTH_DESKTOP;
  if (nextDay === DAY_WIDTH && nextLeft === LEFT_COL_WIDTH && nextParkLeft === PARKING_LEFT_COL_WIDTH) return;
  DAY_WIDTH = nextDay;
  LEFT_COL_WIDTH = nextLeft;
  PARKING_LEFT_COL_WIDTH = nextParkLeft;
  dimListeners.forEach((fn) => fn());
}

export const COLORS = {
  booking: {
    bg: 'hsl(146, 33%, 38%)',
    text: '#fff',
    hover: 'hsl(146, 33%, 32%)',
  },
  airbnb: {
    bg: 'hsl(210, 45%, 46%)',
    text: '#fff',
    hover: 'hsl(210, 45%, 38%)',
  },
  lead: {
    bg: 'hsl(28, 70%, 52%)',
    bgAlpha: 'hsla(28, 70%, 52%, 0.25)',
    stripe: 'hsla(28, 70%, 52%, 0.45)',
    text: 'hsl(28, 70%, 30%)',
    hover: 'hsla(28, 70%, 52%, 0.35)',
  },
  vacant: 'hsl(220, 14%, 95%)',
  todayLine: 'hsl(0, 74%, 50%)',
  monthBorder: 'hsl(220, 14%, 88%)',
  background: 'hsl(0, 0%, 100%)',
};

export function dateToX(d, rangeStart) {
  return differenceInDays(d, rangeStart) * DAY_WIDTH;
}

export function dateSpanWidth(start, end) {
  return Math.max(differenceInDays(end, start) * DAY_WIDTH, DAY_WIDTH);
}

export function clampDate(d, rangeStart, rangeEnd) {
  if (isBefore(d, rangeStart)) return rangeStart;
  if (isAfter(d, rangeEnd)) return rangeEnd;
  return d;
}

export function formatRent(amount) {
  if (amount == null) return 'N/A';
  return `$${Number(amount).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
}
